// client/src/components/messages/MarkdownRenderer.js
import React from 'react';
import { Typography } from '@mui/material';

const MarkdownRenderer = ({ content, contentType = 'plain' }) => {
  if (contentType === 'plain') {
    return (
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {content}
      </Typography>
    );
  }

  // Render markdown
  const renderMarkdown = (text) => {
    if (!text) return '';
    
    let html = text;
    
    // Escape HTML to prevent XSS
    html = html.replace(/&/g, '&amp;')
               .replace(/</g, '&lt;')
               .replace(/>/g, '&gt;');
    
    // Bold
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    // Italic
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    // Code
    html = html.replace(/`(.*?)`/g, '<code style="background: #f5f5f5; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>');
    // Links
    html = html.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">$1</a>');
    // Bullet lists
    html = html.replace(/^- (.+)$/gm, '<li>$1</li>');
    html = html.replace(/(<li>.*<\/li>)/s, '<ul style="margin: 8px 0; padding-left: 20px;">$1</ul>');
    // Quotes
    html = html.replace(/^&gt; (.+)$/gm, '<blockquote style="border-left: 3px solid #ccc; padding-left: 12px; margin: 8px 0; color: #666;">$1</blockquote>');
    // Line breaks
    html = html.replace(/\n/g, '<br/>');
    
    return html;
  };

  return (
    <Typography
      component="div"
      variant="body1"
      dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
      sx={{ 
        whiteSpace: 'pre-wrap', 
        wordBreak: 'break-word',
        '& code': { fontFamily: 'monospace' },
        '& a': { color: '#1976d2' }
      }}
    />
  );
};

export default MarkdownRenderer;
